<template>
  <div class="right">
    <div class="field_left">
      <text-input id="protocolname"
                  :required="true"
                  v-model="entity.name"
                  ref="nameref"
                  :disabled="!$_updateActionAllowed"
      >
        <translate class="translate">Název</translate>
      </text-input>
      <text-input id="protocolcode"
                  :required="true"
                  v-model="entity.code"
                  ref="coderef"
                  :disabled="!$_updateActionAllowed"
      >
        <translate class="translate">Kód</translate>
      </text-input>
    </div>
    <div class="field_right">
      <text-input id="protocolprefix"
                  :required="true"
                  v-model="entity.prefix"
                  ref="prefixref"
                  :disabled="!$_updateActionAllowed"
      >
        <translate class="translate">Prefix</translate>
      </text-input>
      <text-input id="protocolport"
                  v-model="entity.port"
                  ref="portref"
                  :disabled="!$_updateActionAllowed"
      >
        <translate class="translate">Port</translate>
      </text-input>
    </div>
    <div class="field_left">
      <select-box id="protocoldrmsystem"
                  v-model="entity.drm_system"
                  :options="drmSystemOptions"
                  :disabled="!$_updateActionAllowed"
                  ref="drmsystemref"
      >
        <translate class="translate">DRM systém</translate>
      </select-box>
      <select-box id="protocolencryptionscheme"
                  v-model="entity.encryption_scheme"
                  :options="encryptionSchemeOptions"
                  :disabled="!$_updateActionAllowed"
                  ref="encryptionschemeref"
      >
        <translate class="translate">Šifrovací schéma</translate>
      </select-box>
    </div>
    <div class="field_right">
      <select-box id="protocolcontainerformat"
                  v-model="entity.container_format"
                  :options="containerFormatOptions"
                  :disabled="!$_updateActionAllowed"
                  ref="containerformatref"
      >
        <translate class="translate">Formát kontejneru</translate>
      </select-box>
      <text-input id="protocolmaxplayerttl"
                  v-model="entity.max_player_ttl_seconds"
                  ref="maxplayerttlref"
                  :disabled="!$_updateActionAllowed"
      >
        <translate class="translate">Max. TTL přehrávače (s)</translate>
      </text-input>
    </div>
    <div class="field">
      <JSONTextareaInput id="protocolbackendconfig"
                         v-model="entity.backend_config"
                         rows="15"
                         :disabled="!$_updateActionAllowed"
                         ref="backendconfigref"
      >
        <translate class="translate">Backend konfigurace (JSON)</translate>
      </JSONTextareaInput>
    </div>
  </div>
</template>

<script>
import TextInput from "@/components/common/TextInput"
import JSONTextareaInput from "@/components/common/JSONTextareaInput"

import formFilterData from "@/components/mixins/form-filter-data"
import requiredFields from "@/components/mixins/required-fields"

export default {
  name: "ProtocolForm",
  components: {TextInput, JSONTextareaInput},
  mixins: [formFilterData, requiredFields],
  props: {
    entity: Object,
  },
  computed: {
    drmSystemOptions() {
      return [
        {id: 'none', text: this.$gettext('Žádný')},
        {id: 'widevine', text: 'Widevine'},
        {id: 'fairplay', text: 'FairPlay'},
        {id: 'playready', text: 'PlayReady'},
        {id: 'clearkey', text: 'ClearKey'},
      ]
    },
    containerFormatOptions() {
      return [
        {id: 'mpegts', text: 'MPEG-TS'},
        {id: 'cmaf', text: 'CMAF'},
      ]
    },
    encryptionSchemeOptions() {
      return [
        {id: null, text: this.$gettext('Žádné')},
        {id: 'cenc', text: 'CENC'},
        {id: 'cbcs', text: 'CBCS'},
      ]
    },
  },
  methods: {
    validateProtocolFormRequiredFields() {
      let nameError = null
      let codeError = null
      let prefixError = null

      if (!this.entity.name) {
        nameError = this.$gettext('Zadejte název')
      }

      if (!this.entity.code) {
        codeError = this.$gettext('Zadejte kód')
      } else if (this.entity.code.length < 2) {
        codeError = this.$gettext('Kód musí obsahovat min. 2 znaky')
      }

      if (!this.entity.prefix) {
        prefixError = this.$gettext('Zadejte prefix')
      } else if (this.entity.prefix.length < 2) {
        prefixError = this.$gettext('Prefix musí obsahovat min. 2 znaky')
      }

      if (nameError !== null) {
        this.setFieldInvalid('nameref', true, nameError)
      } else {
        this.setFieldInvalid('nameref')
      }

      if (codeError !== null) {
        this.setFieldInvalid('coderef', true, codeError)
      } else {
        this.setFieldInvalid('coderef')
      }

      if (prefixError !== null) {
        this.setFieldInvalid('prefixref', true, prefixError)
      } else {
        this.setFieldInvalid('prefixref')
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/protocols/ProtocolForm.vue